import { BUDGET_RANGE_FILTER_CONFIG, NUM_PEOPLE_FILTER_CONFIG, NUM_PEOPLE_DEFAULT_FILTER_CONFIG, MULTIPLE_CATEGORIES_FILTER_CONFIG, type ActivityFilterConfig, LOCATION_RADIUS_FILTER_CONFIG } from '~/features/activities/ActivityFilterBar/config';
import { usePlpExperiment } from '~/features/activities/search/plpExperiment';
import { ActivityFiltersLayout } from '..';
namespace ACTIVITY_FILTER_BAR_PRESET {
  export const FILTERS = [LOCATION_RADIUS_FILTER_CONFIG, BUDGET_RANGE_FILTER_CONFIG, NUM_PEOPLE_FILTER_CONFIG, MULTIPLE_CATEGORIES_FILTER_CONFIG] as const satisfies readonly ActivityFilterConfig<any, any>[];

  /** The reworked bar: only the three values that drive the price, in the
   * order visitors use them. Categories move to the sidebar, they are used in
   * about 5% of searches. */
  export const FINETUNING_FILTERS = [NUM_PEOPLE_DEFAULT_FILTER_CONFIG, LOCATION_RADIUS_FILTER_CONFIG, BUDGET_RANGE_FILTER_CONFIG] as const satisfies readonly ActivityFilterConfig<any, any>[];

  /** The bar the visitor's experiment group should see. */
  export function useFilters() {
    return usePlpExperiment() ? FINETUNING_FILTERS : FILTERS;
  }
  export const DEFAULTS = ActivityFiltersLayout.createDefaultValues<typeof FILTERS>({
    nearLat: null,
    nearLng: null,
    nearLabel: null,
    radius: null,
    nearCleared: null,
    location: [],
    sort: null,
    minBudget: undefined,
    maxBudget: undefined,
    participants: undefined,
    categories: [],
    subCategories: []
  });
  export const useFilterState = ActivityFiltersLayout.createStateHook<typeof FILTERS>(DEFAULTS);
}
export default ACTIVITY_FILTER_BAR_PRESET;